import { init as initApm } from '@elastic/apm-rum';
import config from './config';

const apm = config.REACT_APP_ENVIRONMENT !== 'development'
  ? initApm({
    serviceName: 'dzo-webshop',
    serverUrl: 'https://apm-rum.kompare.hr/',
    environment: config.REACT_APP_ENVIRONMENT,
    serviceVersion: '1.0.0',
    distributedTracingOrigins: [/.*graphql.*/, /.*api.*/],
    propagateTracestate: true,
    breakdownMetrics: true
  })
  : undefined;

export default apm;